import { TrackingRegion } from '../../../common/AnalyticsContext/TrackingData';
import { Heading } from '../../../common/components/Typography/Heading/Heading';
import { Col } from '../../../common/components/layout/FlexLayout';
import { PageSection } from '../../../common/components/layout/PageSection/PageSection';
import { PopularSearchLink, PopularSearchRow } from './PopularSearchesSection.styles';

export const PopularSearchesSection = () => (
  <PageSection trackingRegionId={TrackingRegion.POPULAR_SEARCHES}>
    <Heading h3>Popular searches</Heading>
    <PopularSearchRow>
      <Col>
        <Heading h4>Doctors</Heading>
        <PopularSearchLink to="/find/gp/NSW/Sydney/">Doctors Sydney</PopularSearchLink>
        <PopularSearchLink to="/find/gp/VIC/Melbourne/">Doctors Melbourne</PopularSearchLink>
        <PopularSearchLink to="/find/gp/ACT/Canberra/">Doctors Canberra</PopularSearchLink>
        <PopularSearchLink to="/find/gp/WA/Perth/">Doctors Perth</PopularSearchLink>
        <PopularSearchLink to="/find/gp/QLD/Brisbane/">Doctors Brisbane</PopularSearchLink>
        <PopularSearchLink to="/find/gp/SA/Adelaide/">Doctors Adelaide</PopularSearchLink>
        <PopularSearchLink to="/find/gp/TAS/Hobart/">Doctors Hobart</PopularSearchLink>
        <PopularSearchLink to="/find/gp/NT/Darwin/">Doctors Darwin</PopularSearchLink>
      </Col>
      <Col>
        <Heading h4>Bulk billing GPs</Heading>
        <PopularSearchLink to="/appointments/gp/NSW/Sydney/Today/">
          Bulk billing GPs Sydney
        </PopularSearchLink>
        <PopularSearchLink to="/appointments/gp/VIC/Melbourne/Today/">
          Bulk billing GPs Melbourne
        </PopularSearchLink>
        <PopularSearchLink to="/appointments/gp/ACT/Canberra/Today/">
          Bulk billing GPs Canberra
        </PopularSearchLink>
        <PopularSearchLink to="/appointments/gp/WA/Perth/Today/">
          Bulk billing GPs Perth
        </PopularSearchLink>
        <PopularSearchLink to="/appointments/gp/QLD/Brisbane/Today/">
          Bulk billing GPs Brisbane
        </PopularSearchLink>
        <PopularSearchLink to="/appointments/gp/SA/Adelaide/Today/">
          Bulk billing GPs Adelaide
        </PopularSearchLink>
        <PopularSearchLink to="/appointments/gp/TAS/Hobart/Today/">
          Bulk billing GPs Hobart
        </PopularSearchLink>
        <PopularSearchLink to="/appointments/gp/NT/Darwin/Today/">
          Bulk billing GPs Darwin
        </PopularSearchLink>
      </Col>
      <Col>
        <Heading h4>After hours GPs</Heading>
        <PopularSearchLink to="/appointments/after-hours/gp/SA/Adelaide/Today/">
          After hours GPs Adelaide
        </PopularSearchLink>
        <PopularSearchLink to="/appointments/after-hours/gp/QLD/Brisbane/Today/">
          After hours GPs Brisbane
        </PopularSearchLink>
        <PopularSearchLink to="/appointments/after-hours/gp/ACT/Canberra/Today/">
          After hours GPs Canberra
        </PopularSearchLink>
        <PopularSearchLink to="/appointments/after-hours/gp/NT/Darwin/Today/">
          After hours GPs Darwin
        </PopularSearchLink>
        <PopularSearchLink to="/appointments/after-hours/gp/TAS/Hobart/Today/">
          After hours GPs Hobart
        </PopularSearchLink>
        <PopularSearchLink to="/appointments/after-hours/gp/VIC/Melbourne/Today/">
          After hours GPs Melbourne
        </PopularSearchLink>
        <PopularSearchLink to="/appointments/after-hours/gp/WA/Perth/Today/">
          After hours GPs Perth
        </PopularSearchLink>
        <PopularSearchLink to="/appointments/after-hours/gp/NSW/Sydney/Today/">
          After hours GPs Sydney
        </PopularSearchLink>
      </Col>
      <Col>
        <Heading h4>Dentists</Heading>
        <PopularSearchLink to="/appointments/dentist/SA/Adelaide/Today/">
          Dentists Adelaide
        </PopularSearchLink>
        <PopularSearchLink to="/appointments/dentist/QLD/Brisbane/Today/">
          Dentists Brisbane
        </PopularSearchLink>
        <PopularSearchLink to="/appointments/dentist/ACT/Canberra/Today/">
          Dentists Canberra
        </PopularSearchLink>
        <PopularSearchLink to="/appointments/dentist/NT/Darwin/Today/">
          Dentists Darwin
        </PopularSearchLink>
        <PopularSearchLink to="/appointments/dentist/TAS/Hobart/Today/">
          Dentists Hobart
        </PopularSearchLink>
        <PopularSearchLink to="/appointments/dentist/VIC/Melbourne/Today/">
          Dentists Melbourne
        </PopularSearchLink>
        <PopularSearchLink to="/appointments/dentist/WA/Perth/Today/">
          Dentists Perth
        </PopularSearchLink>
        <PopularSearchLink to="/appointments/dentist/NSW/Sydney/Today/">
          Dentists Sydney
        </PopularSearchLink>
      </Col>
      <Col>
        <Heading h4>Physiotherapists</Heading>
        <PopularSearchLink to="/appointments/physiotherapist/SA/Adelaide/Next7Days/">
          Physiotherapists Adelaide
        </PopularSearchLink>
        <PopularSearchLink to="/appointments/physiotherapist/QLD/Brisbane/Next7Days/">
          Physiotherapists Brisbane
        </PopularSearchLink>
        <PopularSearchLink to="/appointments/physiotherapist/ACT/Canberra/Next7Days/">
          Physiotherapists Canberra
        </PopularSearchLink>
        <PopularSearchLink to="/appointments/physiotherapist/NT/Darwin/Next7Days/">
          Physiotherapists Darwin
        </PopularSearchLink>
        <PopularSearchLink to="/appointments/physiotherapist/TAS/Hobart/Next7Days/">
          Physiotherapists Hobart
        </PopularSearchLink>
        <PopularSearchLink to="/appointments/physiotherapist/VIC/Melbourne/Next7Days/">
          Physiotherapists Melbourne
        </PopularSearchLink>
        <PopularSearchLink to="/appointments/physiotherapist/WA/Perth/Next7Days/">
          Physiotherapists Perth
        </PopularSearchLink>
        <PopularSearchLink to="/appointments/physiotherapist/NSW/Sydney/Next7Days/">
          Physiotherapists Sydney
        </PopularSearchLink>
      </Col>
      <Col>
        <Heading h4>COVID-19 Vaccination</Heading>
        <PopularSearchLink to="/appointments/covid--19-vaccinations/SA/Adelaide/NextAvailable/">
          COVID-19 Vaccine Adelaide
        </PopularSearchLink>
        <PopularSearchLink to="/appointments/covid--19-vaccinations/QLD/Brisbane/NextAvailable/">
          COVID-19 Vaccine Brisbane
        </PopularSearchLink>
        <PopularSearchLink to="/appointments/covid--19-vaccinations/ACT/Canberra/NextAvailable/">
          COVID-19 Vaccine Canberra
        </PopularSearchLink>
        <PopularSearchLink to="/appointments/covid--19-vaccinations/NT/Darwin/NextAvailable/">
          COVID-19 Vaccine Darwin
        </PopularSearchLink>
        <PopularSearchLink to="/appointments/covid--19-vaccinations/TAS/Hobart/NextAvailable/">
          COVID-19 Vaccine Hobart
        </PopularSearchLink>
        <PopularSearchLink to="/appointments/covid--19-vaccinations/VIC/Melbourne/NextAvailable/">
          COVID-19 Vaccine Melbourne
        </PopularSearchLink>
        <PopularSearchLink to="/appointments/covid--19-vaccinations/WA/Perth/NextAvailable/">
          COVID-19 Vaccine Perth
        </PopularSearchLink>
        <PopularSearchLink to="/appointments/covid--19-vaccinations/NSW/Sydney/NextAvailable/">
          COVID-19 Vaccine Sydney
        </PopularSearchLink>
      </Col>
    </PopularSearchRow>
  </PageSection>
);
